// Menu: Small Bar
// 

JLM.MD.MenuBarSmall = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let but_menu, but_search, but_shortlist, counter_shortlist;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let but_contact, link_brand;
		
		// Fetch references
		but_menu = $('button[data-action="toggle"]', container);
		but_contact = $('button[data-action="contact"]', container);
		but_search = $('button[data-action="search"]', container);
		but_shortlist = $('button[data-action="shortlist"]', container);
			counter_shortlist = new JLM.MD.MenuBarCounter( but_shortlist );
		link_brand = $('a.branding', container);
		
		// Events
		container.on('mouseover', onMouseOver).on('click', onClickBar);
		but_menu.on('click', toggleMenu);
		but_contact.on('click', navigateToContact);
		but_search.on('click', toggleSearch);
		but_shortlist.on('click', toggleShortlist);
		link_brand.on('click', onClickMenu);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Hover
	// 
	function onMouseOver() {
		INSTANCE.dispatchEvent('mouseover');
		container.one('mouseout', function() {
			INSTANCE.dispatchEvent('mouseout');
		});
	}
	
	
	// Event: Click menu/bar
	// 
	function onClickMenu( event ) {
		// Layout: Desktop
		if ( but_search.is(':visible') ) {
			toggleMenu();
			return false;
		}
		// Layout: Mobile
		else {}
	}
	function onClickBar( event ) {
		if ( $(event.target)[0] == container[0] ) {
			onClickMenu( event );
		}
	}
	
	
	// Bubbling Events
	// 
	function toggleMenu() {
		INSTANCE.dispatchEvent('toggle_menu');
	}
	function navigateToContact() {
		INSTANCE.dispatchEvent('navigate_contact');
	}
	function toggleSearch() {
		INSTANCE.dispatchEvent('toggle_search');
	}
	function toggleShortlist() {
		INSTANCE.dispatchEvent('toggle_shortlist');
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update selected states
	// 
	INSTANCE.selectMenu = function() {
		but_menu.addClass('open');
		but_search.removeClass('open');
		but_shortlist.removeClass('open');
	};
	INSTANCE.selectSearch = function() {
		but_menu.removeClass('open');
		but_search.addClass('open');
		but_shortlist.removeClass('open');
	};
	INSTANCE.selectShortlist = function() {
		but_menu.removeClass('open');
		but_search.removeClass('open');
		but_shortlist.addClass('open');
	};
	INSTANCE.unselect = function() {
		but_menu.removeClass('open');
		but_search.removeClass('open');
		but_shortlist.removeClass('open');
	};
	
	
	// Update shortlist tally
	// 
	INSTANCE.updateShortlistTally = function( tally, is_setup ) {
		counter_shortlist.update( tally, is_setup );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};